module.exports = __webpack_public_path__ + "static/media/14_tn.91b7720c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/14_tn.jpg
// module id = 650
// module chunks = 0